import * as React from 'react'
import "./headline.scss"

const Headline = ({componentData: {priority, headline}}) => {
  return <span className={"headline " + priority}>{headline}</span>
}

export default Headline
